<template>
  <body>
    <head>
      <meta charset="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link rel="icon" href="img/favicon.ico" />
      <link rel="stylesheet" href="theme.css" type="text/css" />
      <title>Porto - Portal de Autonegociação</title>
    </head>

    <body>
      <!-- ========== NOVO LAYOUT LOGIN (imagem à esquerda desktop / imagem abaixo mobile) ========== -->
      <!-- Desktop largo (>= 1200px): fundo #0046C0, imagem à esquerda, card à direita -->
      <div
        v-if="largura >= 1200"
        class="login-new-wrapper login-new-desktop"
      >
        <div class="login-new-left">
          <img
            class="login-new-hero-img"
            src="/img/image-mobile.png?v=2611"
            alt=""
          />
        </div>
        <div class="login-new-right">
          <div class="card shadow-sm login-new-card">
            <div class="card-body px-4 py-4">
              <h5 class="text-body mb-1" style="font-weight: 600;">Negociação de dívidas</h5>
              <h6 class="text-muted mb-4" style="font-size: 0.95rem;">
                Descubra as melhores condições para você quitar suas dívidas com o Porto Bank.
              </h6>
              <form @submit.prevent>
                <div class="form-group mb-3">
                  <input
                    type="text"
                    required
                    class="form-control form-control-sm"
                    placeholder="CPF ou CNPJ"
                    id="accessDocInput"
                    v-mask="['###.###.###-##', 'XX.XXX.XXX/XXXX-##']"
                    @keyup="convertToUpperCase"
                    style="text-transform: uppercase;"
                    v-model="form.accessdoc"
                    :disabled="showChannelSelect"
                    @change="changeAccessDocInput(form.accessdoc)"
                    @input="saveDocument"
                  />
                </div>
                <div v-if="!showChannelSelect">
                  <button
                    @click="getContacts(true)"
                    id="btn-receber-token"
                    type="button"
                    v-if="!loading"
                    class="btn btn-primary p-3 w-100 mb-3"
                    style="border-radius: 6px; font-size: 16px; background-color: #0046C0; border-color: #0046C0;"
                  >
                    Receber Token
                  </button>
                  <div v-else class="login-card-loading mb-3">
                    <ProgressLoading v-bind:loading="loading" />
                  </div>
                </div>

                <InlineChannelSelect v-if="showChannelSelect" :key="'channel-' + channelSelectKey" />
              </form>
            </div>
          </div>
        </div>
      </div>

      <!-- Desktop estreito / monitor vertical (501px–1199px): empilhado, imagem em cima colada no card -->
      <div
        v-if="largura >= 501 && largura < 1200"
        class="login-new-wrapper login-new-desktop-stacked"
        style="background-color: #0046C0; min-height: 100vh; padding: 1.5rem; display: flex; flex-direction: column; align-items: center; justify-content: center;"
      >
        <div class="login-new-stacked-block" style="max-width: 420px; width: 100%; flex-shrink: 0; box-sizing: border-box; margin: 0 auto;">
          <div style="border-radius: 12px 12px 0 0; overflow: hidden; width: 100%;">
            <img
              src="/img/image-mobile.png?v=2611"
              alt=""
              style="width: 100%; max-width: 100%; height: auto; max-height: 45vh; object-fit: cover; object-position: center top; display: block; margin: 0; padding: 0;"
            />
          </div>
          <div class="card login-new-card login-new-stacked-card" style="width: 100%; margin-top: 0; border: none; border-radius: 0 0 24px 24px; box-sizing: border-box; box-shadow: none;">
            <div class="card-body px-4 py-4">
              <h5 class="text-body mb-1" style="font-weight: 600;">Negociação de dívidas</h5>
              <h6 class="text-muted mb-4" style="font-size: 0.95rem;">
                Descubra as melhores condições para você quitar suas dívidas com o Porto Bank.
              </h6>
              <form @submit.prevent>
                <div class="form-group mb-3">
                  <input
                    type="text"
                    required
                    class="form-control form-control-sm"
                    placeholder="CPF ou CNPJ"
                    v-mask="['###.###.###-##', 'XX.XXX.XXX/XXXX-##']"
                    @keyup="convertToUpperCase"
                    style="text-transform: uppercase;"
                    v-model="form.accessdoc"
                    :disabled="showChannelSelect"
                    @change="changeAccessDocInput(form.accessdoc)"
                    @input="saveDocument"
                  />
                </div>
                <div v-if="!showChannelSelect">
                  <button
                    @click="getContacts(true)"
                    type="button"
                    v-if="!loading"
                    class="btn btn-primary p-3 w-100 mb-3"
                    style="border-radius: 6px; font-size: 16px; background-color: #0046C0; border-color: #0046C0;"
                  >
                    Receber Token
                  </button>
                  <div v-else class="login-card-loading mb-3">
                    <ProgressLoading v-bind:loading="loading" />
                  </div>
                </div>

                <InlineChannelSelect v-if="showChannelSelect" :key="'channel-' + channelSelectKey" />
              </form>
            </div>
          </div>
        </div>
      </div>

      <!-- Mobile: card em cima, imagem abaixo (margem igual à Landing, sem travar no layout pai) -->
      <div
        v-if="largura <= 500"
        class="login-new-wrapper login-new-mobile"
        style="min-height: 100vh; background-color: #0046C0; display: flex; flex-direction: column; align-items: center; box-sizing: border-box; width: 100%; max-width: 100vw; margin-left: auto; margin-right: auto; padding: 2rem 1.25rem 1rem 1.25rem;"
      >
        <div class="login-new-mobile-block" style="max-width: 420px; width: 100%; box-sizing: border-box;">
          <div class="card login-new-card login-new-mobile-card" style="margin-bottom: 0; border: none; border-radius: 12px 12px 0 0; width: 100%; box-sizing: border-box; box-shadow: none;">
            <div class="card-body px-4 py-4">
            <h5 class="text-body mb-1" style="font-weight: 600;">Negociação de dívidas</h5>
            <h6 class="text-muted mb-4" style="font-size: 0.95rem;">
              Descubra as melhores condições para você quitar suas dívidas com o Porto Bank.
            </h6>
            <form @submit.prevent>
              <div class="form-group mb-3">
                <input
                  type="text"
                  required
                  class="form-control form-control-sm"
                  placeholder="CPF ou CNPJ"
                  id="accessDocInput"
                  v-mask="['###.###.###-##', 'XX.XXX.XXX/XXXX-##']"
                  @keyup="convertToUpperCase"
                  style="text-transform: uppercase;"
                  v-model="form.accessdoc"
                  :disabled="showChannelSelect"
                  @change="changeAccessDocInput(form.accessdoc)"
                  @input="saveDocument"
                />
              </div>
              <div v-if="!showChannelSelect">
                <button
                  @click="getContacts(true)"
                  id="btn-receber-token"
                  type="button"
                  v-if="!loading"
                  class="btn btn-primary p-3 w-100 mb-3"
                  style="border-radius: 6px; font-size: 16px;"
                >
                  Receber Token
                </button>
                <div v-else class="login-card-loading mb-3">
                  <ProgressLoading v-bind:loading="loading" />
                </div>
              </div>

              <InlineChannelSelect v-if="showChannelSelect" :key="'channel-' + channelSelectKey" />
            </form>
            </div>
          </div>
          <img
            src="/img/image-mobile.png?v=2611"
            alt=""
            class="login-new-mobile-img-below"
            style="display: block; width: 100%; border-radius: 0 0 12px 12px; object-fit: cover; object-position: center;"
          />
        </div>
      </div>

      <!-- ========== LAYOUT ANTIGO (desativado com v-if="false &&" – para reativar, remover "false &&" dos v-if abaixo) ========== -->
      <!-- SEM BANNER desktop -->
      <div class="capa1" style="" v-if="false && this.largura > 500 && !thereIsBanner" >
        <div v-bind:class="[this.largura > 500 ? 'container' : 'container']">
          <div v-bind:class="[this.largura > 500 ? 'row' : 'row']">
            
            <div class="pt-4 col-lg-5" v-if="this.largura > 500">
              <h1
                class="pl-0 text-white col-1 d-none d-lg-block mt-5 col-lg-12"
                style=""
              >
                Negocie suas dívidas para você ficar no azul!
              </h1>

            <!-- <img
              src="/img/banner-feirao.png"
              alt=""
              style="width: 100%; margin-left: 25px;"
            /> -->
          </div>
          <div class="col-lg-2">

            </div>
          <!-- <div class="col-lg-4"></div> -->
          <div
            class="col-lg-5 justify-content-center d-flex"
            style="margin-bottom: 100px;"
          >
            <div class="card" style="max-height: max-content; margin-left: 100px; max-width: 450px;">
              <div class="border-top-0 px-3 pt-3">
                <h5 class="text-body">Negociação de Dívidas</h5>
                <h6 class="text-muted mb-3">
                  Descubra as melhores condições para você quitar suas dívidas
                  com o Porto Bank.
                </h6>
                <form>
                  <div class="form-group mb-3">
                    <div class="form-group">
                      <input
                        type="text"
                        required
                        class="form-control form-control-sm"
                        placeholder="Seu CPF ou CNPJ"
                        id="accessDocInput"
                        label="Digite"
                        v-mask="['###.###.###-##', 'XX.XXX.XXX/XXXX-##']"
                        @keyup="convertToUpperCase"
                        style="text-transform: uppercase;"
                        v-model="form.accessdoc"
                        @change="changeAccessDocInput(form.accessdoc)"
                        @input="saveDocument"
                      />
                    </div>
                    <div class="form-group mb-3 position-relative">
                      <input
                        :type="isPasswordVisible ? 'text' : 'password'"
                        class="form-control form-control-sm"
                        placeholder="Código de acesso"
                        id="passwordInput"
                        v-model="form.promoCode"
                        :disabled="loading"
                        @change="changeAccessCodeInput()"
                      />
                      <PasswordToggleButton
                        :isPasswordVisible="isPasswordVisible"
                        @toggle-visibility="togglePasswordVisibility"
                      />
                    </div>
                    <div class="row">
                      <div
                        class="col-12 d-flex align-items-baseline justify-content-between"
                      >
                        <small class="form-text text-muted">
                          <a href="#" @click="getContacts(true)" class="mt-4">
                            Quero receber o código</a
                          >
                        </small>
                        <small class="form-text text-muted">
                          <a
                            href="#"
                            @click="getContacts(false)"
                            class="mt-4 text-right"
                            >Esqueci o código</a
                          >
                        </small>
                      </div>
                    </div>
                  </div>
                  <button
                    @click="login"
                    id="btn-negociar"
                    type="button"
                    v-if="!loading"
                    :disabled="!form.promoCode && !form.accessdoc"
                    class="btn mb-2 btn-primary p-3"
                    style="width: 100%; border-radius: 6px; font-size: 16px"
                  >
                    Negociar agora
                  </button>
                </form>
                <div class="mt-3">
                  <ProgressLoading v-bind:loading="loading" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>

      <!-- COM BANNER desktop -->
      <div class="capa1"
        :style="{
          backgroundImage: 'url(/img/fundo-complementar.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'top',
          backgroundRepeat: 'no-repeat',
          width: '100%',
          height: '40dvh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          margin: '-18px',
        }" 
        v-if="false && this.largura > 500 && thereIsBanner" >
        <div v-bind:class="[this.largura > 500 ? 'container' : 'container']">
          <div v-bind:class="[this.largura > 500 ? 'row' : 'row']">
            
            <div class="pt-4 col-lg-7" v-if="this.largura > 500">
            <img
              src="/img/banner-porto.jpg"
              alt=""
              style="width: 120%; height: 70%; margin-left: 25px;"
            />
          </div>
          <!-- <div class="col-lg-2">

            </div> -->
          <!-- <div class="col-lg-4"></div> -->
          <div
            class="col-lg-5 justify-content-center d-flex"
            style="margin-bottom: 100px;"
          >
            <div class="card" style="max-height: max-content; margin-left: 100px; max-width: 450px;">
              <div class="border-top-0 px-3 pt-3">
                <h5 class="text-body">Negociação de Dívidas</h5>
                <h6 class="text-muted mb-3">
                  Descubra as melhores condições para você quitar suas dívidas
                  com o Porto Bank.
                </h6>
                <form>
                  <div class="form-group mb-3">
                    <div class="form-group">
                      <input
                        type="text"
                        required
                        class="form-control form-control-sm"
                        placeholder="Seu CPF ou CNPJ"
                        id="accessDocInput"
                        label="Digite"
                        v-mask="['###.###.###-##', 'XX.XXX.XXX/XXXX-##']"
                        @keyup="convertToUpperCase"
                        style="text-transform: uppercase;"
                        v-model="form.accessdoc"
                        @change="changeAccessDocInput(form.accessdoc)"
                        @input="saveDocument"
                      />
                    </div>
                    <div class="form-group mb-3 position-relative">
                      <input
                        :type="isPasswordVisible ? 'text' : 'password'"
                        class="form-control form-control-sm"
                        placeholder="Código de acesso"
                        id="passwordInput"
                        v-model="form.promoCode"
                        :disabled="loading"
                        @change="changeAccessCodeInput()"
                      />
                      <PasswordToggleButton
                        :isPasswordVisible="isPasswordVisible"
                        @toggle-visibility="togglePasswordVisibility"
                      />
                    </div>
                    <div class="row">
                      <div
                        class="col-12 d-flex align-items-baseline justify-content-between"
                      >
                        <small class="form-text text-muted">
                          <a href="#" @click="getContacts(true)" class="mt-4">
                            Quero receber o código</a
                          >
                        </small>
                        <small class="form-text text-muted">
                          <a
                            href="#"
                            @click="getContacts(false)"
                            class="mt-4 text-right"
                            >Esqueci o código</a
                          >
                        </small>
                      </div>
                    </div>
                  </div>
                  <button
                    @click="login"
                    id="btn-negociar"
                    type="button"
                    v-if="!loading"
                    :disabled="!form.promoCode && !form.accessdoc"
                    class="btn mb-2 btn-primary p-3"
                    style="width: 100%; border-radius: 6px; font-size: 16px"
                  >
                    Negociar agora
                  </button>
                </form>
                <div class="mt-3">
                  <ProgressLoading v-bind:loading="loading" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>

      <!-- SEM BANNER mobile -->
      <div class="capa1" style="height: 60dvh;" v-if="false && this.largura < 500 && !thereIsBanner">
      <div class="container p-0 pr-3 pl-3" >
        <!-- <img
          src="/img/banner-feirao.png"
          alt=""
          style="width: 100%;"
        /> -->

        <div
        >
          <div class="container">
            <div class="col-12">
              <div class="card">
                <div class="border-top-0 px-3 pt-3">
                  <h5 class="text-body">Negociação de Dívidas</h5>
                  <h6 class="text-muted mb-3">
                    Descubra as melhores condições para você quitar suas dívidas
                    com o Porto Bank.
                  </h6>
                  <form>
                    <div class="form-group mb-3">
                      <div class="form-group">
                        <input
                          type="text"
                          required
                          class="form-control form-control-sm"
                          placeholder="Seu CPF ou CNPJ"
                          id="accessDocInput"
                          label="Digite"
                          v-mask="['###.###.###-##', 'XX.XXX.XXX/XXXX-##']"
                        @keyup="convertToUpperCase"
                        style="text-transform: uppercase;"
                          v-model="form.accessdoc"
                          @change="changeAccessDocInput(form.accessdoc)"
                          @input="saveDocument"
                        />
                      </div>
                      <div class="form-group mb-3 position-relative">
                        <input
                          :type="isPasswordVisible ? 'text' : 'password'"
                          class="form-control form-control-sm"
                          placeholder="Código de acesso"
                          id="passwordInput"
                          v-model="form.promoCode"
                          :disabled="loading"
                          @change="changeAccessCodeInput()"
                        />
                        <PasswordToggleButton
                          :isPasswordVisible="isPasswordVisible"
                          @toggle-visibility="togglePasswordVisibility"
                        />
                      </div>
                      <div class="row">
                        <div
                          class="col-12 d-flex align-items-baseline justify-content-between"
                        >
                          <small class="form-text text-muted">
                            <a
                              @click="getContacts(true)"
                              class="mt-4"
                              style="color: #0046C0; cursor: pointer"
                            >
                              Quero receber o código</a
                            >
                          </small>
                          <small class="form-text text-muted">
                            <a
                              @click="getContacts(false)"
                              class="mt-4 text-right"
                              style="color: #0046C0; cursor: pointer"
                              >Esqueci o código</a
                            >
                          </small>
                        </div>
                      </div>
                    </div>
                    <button
                      @click="login"
                      id="btn-negociar"
                      type="button"
                      v-if="!loading"
                      :disabled="!form.promoCode && !form.accessdoc"
                      class="btn mb-2 btn-primary p-3"
                      style="width: 100%; border-radius: 6px; font-size: 16px"
                    >
                      Negociar agora
                    </button>
                  </form>
                  <div class="mt-3">
                    <ProgressLoading v-bind:loading="loading" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>

      <!-- COM BANNER mobile -->
      <div class="capa1" 
      :style="{
          backgroundImage: 'url(/img/fundo-complementar.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'top',
          backgroundRepeat: 'no-repeat',
          width: '100%',
          height: '55vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          marginTop: '-5px',
          zIndex: '0'
        }" 
        v-if="false && this.largura < 500 && thereIsBanner">
      <div class="container p-0 pr-3 pl-3" >
        <img
          src="/img/banner-porto.jpg"
          alt=""
          style="width: 100%;"
        />

        <div
        >
          <div class="container">
            <div class="col-12">
              <div class="card">
                <div class="border-top-0 px-3 pt-3">
                  <h5 class="text-body">Negociação de Dívidas</h5>
                  <h6 class="text-muted mb-3">
                    Descubra as melhores condições para você quitar suas dívidas
                    com o Porto Bank.
                  </h6>
                  <form>
                    <div class="form-group mb-3">
                      <div class="form-group">
                        <input
                          type="text"
                          required
                          class="form-control form-control-sm"
                          placeholder="Seu CPF ou CNPJ"
                          id="accessDocInput"
                          label="Digite"
                          v-mask="['###.###.###-##', 'XX.XXX.XXX/XXXX-##']"
                        @keyup="convertToUpperCase"
                        style="text-transform: uppercase;"
                          v-model="form.accessdoc"
                          @change="changeAccessDocInput(form.accessdoc)"
                          @input="saveDocument"
                        />
                      </div>
                      <div class="form-group mb-3 position-relative">
                        <input
                          :type="isPasswordVisible ? 'text' : 'password'"
                          class="form-control form-control-sm"
                          placeholder="Código de acesso"
                          id="passwordInput"
                          v-model="form.promoCode"
                          :disabled="loading"
                          @change="changeAccessCodeInput()"
                        />
                        <PasswordToggleButton
                          :isPasswordVisible="isPasswordVisible"
                          @toggle-visibility="togglePasswordVisibility"
                        />
                      </div>
                      <div class="row">
                        <div
                          class="col-12 d-flex align-items-baseline justify-content-between"
                        >
                          <small class="form-text text-muted">
                            <a
                              @click="getContacts(true)"
                              class="mt-4"
                              style="color: #0046C0; cursor: pointer"
                            >
                              Quero receber o código</a
                            >
                          </small>
                          <small class="form-text text-muted">
                            <a
                              @click="getContacts(false)"
                              class="mt-4 text-right"
                              style="color: #0046C0; cursor: pointer"
                              >Esqueci o código</a
                            >
                          </small>
                        </div>
                      </div>
                    </div>
                    <button
                      @click="login"
                      id="btn-negociar"
                      type="button"
                      v-if="!loading"
                      :disabled="!form.promoCode && !form.accessdoc"
                      class="btn mb-2 btn-primary p-3"
                      style="width: 100%; border-radius: 6px; font-size: 16px"
                    >
                      Negociar agora
                    </button>
                  </form>
                  <div class="mt-3">
                    <ProgressLoading v-bind:loading="loading" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      <div
        class="sec10 bg-light"
        :style="largura > 500 ? '' : ''"
      >
        <div class="container">
          <div class="row justify-content-center text-center mb-5">
            <div class="col-md-12 text-dark">
              <h2 class="py-4">
                Como fazer a negociação online do seu Cartão de Crédito Porto
                Bank
              </h2>
            </div>
          </div>
          <div
            class="row d-flex justify-content-center text-dark"
            :style="largura < 500 ? 'padding: 40px;' : ''"
          >
            <div class="col-6 col-lg-3 p-2 pl-3 pr-4" style="">
              <img class="img-fluid d-block mb-3" src="img/ic01.jpg" />
              <h5>Identifique-se fazendo o login.</h5>
            </div>
            <div class="col-6 col-lg-3 p-2 pr-4 pl-3" style="">
              <img class="img-fluid d-block mb-3" src="img/ic02.jpg" />
              <h5>Selecione a melhor opção para você.</h5>
            </div>
            <div class="col-6 col-lg-3 p-2 pr-4 pl-3" style="">
              <img class="img-fluid d-block mb-3" src="img/ic03.jpg" />
              <h5 class="" style="">Gere o boleto e faça o pagamento.</h5>
            </div>
            <div class="col-6 col-lg-3 p-2 pr-4 pl-3" style="">
              <img class="img-fluid d-block mb-3" src="img/ic04.jpg" />
              <h5 class="">Pronto! Tudo certo com a sua negociação.</h5>
            </div>
          </div>
        </div>
      </div>
      <section class="bg-light py-3">
        <div class="container py-5">
          <div class="row">
            <div class="col-11 mx-auto">
              <h4>
                Tire suas dúvidas sobre a Negociação de Dívidas
                <hr style="border-color: #fff" />
              </h4>
              <div class="accordion" id="faq">
                <div class="card">
                  <div class="card-header p-2" id="headingOne">
                    <h5 class="mb-0">
                      <button
                        class="btn-link"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapse1"
                        aria-expanded="true"
                        aria-controls="collapse1"
                        style="font-size: 16px"
                      >
                        O que é a negociação de dívidas?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapse1"
                    class="collapse"
                    aria-labelledby="heading1"
                  >
                    <div class="card-body px-4">
                      Negociação de dívidas é uma maneira de
                      <strong>simplificar a quitação</strong> das suas dívidas com
                      nossos produtos financeiros.
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header p-2" id="heading2">
                    <h5 class="mb-0">
                      <button
                        class="btn-link collapsed"
                        type="button"
                        aria-expanded="false"
                        data-target="#collapse2"
                        aria-controls="collapse2"
                        data-toggle="collapse"
                        style="font-size: 16px"
                      >
                        De que forma posso pagar a negociação do cartão de
                        crédito?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapse2"
                    class="collapse"
                    aria-labelledby="heading2"
                  >
                    <div class="card-body px-4">
                      Você pode pagar sua negociação de cartão de crédito por meio
                      de <strong>boleto bancário</strong> ou <strong>Pix</strong>
                      pelo nosso <strong>Portal de Negociação</strong>,
                      <strong>App Porto</strong> ou
                      <strong>WhatsApp Oficial</strong>.
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header p-2" id="heading3">
                    <h5 class="mb-0">
                      <button
                        class="btn-link collapsed"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapse3"
                        aria-expanded="false"
                        aria-controls="collapse3"
                        style="font-size: 16px"
                      >
                        Quanto tempo leva, após o pagamento, para sair das
                        restrições de crédito?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapse3"
                    class="collapse"
                    aria-labelledby="heading3"
                  >
                    <div class="card-body px-4">
                      Depois que você pagar a negociação, seu nome será removido
                      das restrições de crédito em até
                      <strong>5 dias úteis</strong>.
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header p-2" id="heading4">
                    <h5 class="mb-0">
                      <button
                        class="btn-link collapsed"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapse4"
                        aria-expanded="false"
                        aria-controls="collapse4"
                        style="font-size: 16px"
                      >
                        Como posso emitir uma segunda via de boleto de
                        negociação?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapse4"
                    class="collapse"
                    aria-labelledby="heading4"
                  >
                    <div class="card-body px-4">
                      <p class="mb-2">
                        <strong>Para cartão de crédito:</strong> Acesse o portal,
                        App ou WhatsApp Oficial e emita a segunda via do boleto.
                      </p>
                      <p class="mb-0">
                        <strong>Para outros produtos:</strong> Entre em contato
                        com a central de atendimento para solicitar a segunda via.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header p-2" id="heading5">
                    <h5 class="mb-0">
                      <button
                        class="btn-link collapsed"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapse5"
                        aria-expanded="false"
                        aria-controls="collapse5"
                        style="font-size: 16px"
                      >
                        Qual é o prazo para pagamento do boleto da negociação?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapse5"
                    class="collapse"
                    aria-labelledby="heading5"
                  >
                    <div class="card-body px-4">
                      Você tem <strong>até 15 dias</strong> para pagar o boleto da
                      negociação de dívida.
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header p-2" id="heading6">
                    <h5 class="mb-0">
                      <button
                        class="btn-link collapsed"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapse6"
                        aria-expanded="false"
                        aria-controls="collapse6"
                        style="font-size: 16px"
                      >
                        Tenho condições especiais para negociar as minhas
                        dívidas?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapse6"
                    class="collapse"
                    aria-labelledby="heading6"
                    style=""
                  >
                    <div class="card-body px-4">
                      <strong>Sim, você pode ter condições especiais</strong>!
                      Faça o login e acesse nossa página para conferir as
                      condições de negociação.
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header p-2" id="heading7">
                    <h5 class="mb-0">
                      <button
                        class="btn-link collapsed"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapse7"
                        aria-expanded="false"
                        aria-controls="collapse7"
                        style="font-size: 16px"
                      >
                        O que é o Desenrola 2.0?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapse7"
                    class="collapse"
                    aria-labelledby="heading7"
                  >
                    <div class="card-body px-4">
                      O <strong>Desenrola 2.0</strong> é um
                      <strong>programa do Governo Federal Brasileiro</strong> para
                      renegociação de dívidas de famílias, estudantes e empresas com
                      condições diferenciadas.
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header p-2" id="heading8">
                    <h5 class="mb-0">
                      <button
                        class="btn-link collapsed"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapse8"
                        aria-expanded="false"
                        aria-controls="collapse8"
                        style="font-size: 16px"
                      >
                        Quem está elegível ao Desenrola 2.0?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapse8"
                    class="collapse"
                    aria-labelledby="heading8"
                  >
                    <div class="card-body px-4">
                      Estão elegíveis ao <strong>Desenrola 2.0</strong> quem possui
                      renda mensal de
                      <strong>até 5 salários mínimos</strong> (até R$ 8.105),
                      <strong>atraso entre 90 e 2 anos</strong> e o
                      <strong>limite da nova dívida</strong> (após os descontos)
                      <strong>de até R$ 15 mil</strong> por pessoa, por instituição
                      bancária.
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header p-2" id="heading9">
                    <h5 class="mb-0">
                      <button
                        class="btn-link collapsed"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapse9"
                        aria-expanded="false"
                        aria-controls="collapse9"
                        style="font-size: 16px"
                      >
                        Como negociar dívidas no Desenrola 2.0?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapse9"
                    class="collapse"
                    aria-labelledby="heading9"
                  >
                    <div class="card-body px-4">
                      Acesse nossos
                      <strong>canais oficiais de negociação</strong> (Portal de
                      Negociação, App Porto ou WhatsApp Oficial), se identifique e
                      aproveite as condições.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </body>
  </body>
</template>

<script>
import { mapActions } from "vuex";
import { mask } from "vue-the-mask";
import { validationMixin } from "vuelidate";
import { required, minLength, helpers } from "vuelidate/lib/validators";
import { validaCpfCnpj, ActionGetIPAddress } from "@/utils/helpers";
import { hasContacts, CONTACTS_NOT_FOUND_MESSAGE } from "@/utils/authContacts";
import ProgressLoading from "./ProgressLoading.vue";
import { encryptTextWithKey, decryptHashWithKey } from "@/utils/crypto";
import { EventBus } from "@/utils/EventBus";
import { initializeGlobals } from "@/global";
import PasswordToggleButton from "./PasswordToggleButton";
import InlineChannelSelect from "./InlineChannelSelect.vue";

// Regex para CPF (somente números) e CNPJ (alfanumérico ou numérico)
// CNPJ Alfanumérico: posições 1-12 podem ter letras (A-Z) ou números, posições 13-14 são numéricas
const regexaccessdoc = helpers.regex(
  "regexaccessdoc",
  /(^\d{3}\.\d{3}\.\d{3}-\d{2}$)|(^[A-Za-z0-9]{2}\.[A-Za-z0-9]{3}\.[A-Za-z0-9]{3}\/[A-Za-z0-9]{4}-\d{2}$)/
);

export default {
  name: "Login",
  components: {
    ProgressLoading,
    PasswordToggleButton,
    InlineChannelSelect,
  },
  mixins: [validationMixin],
  directives: { mask },
  validations: {
    form: {
      accessdoc: { required, minLength: minLength(14), regexaccessdoc },
    },  
  },
  data: () => ({
    form: {
      accessdoc: null,
      promoCode: null,
      // accessdoc: "45714020820",
      // promoCode: "c8228001", 
      termsAcepted: false,
    },
    error: {
      alert: false,
      status: null,
      message: null,
    },
    errors: false,
    loading: false,
    promoCode: null,
    sendCode: false,
    EmailOrPhone: "email",
    email: true,
    sms: false,
    code: false,
    emailDebtor: null,
    smsDebtor: null,
    infoDebtor: null,
    user: null,
    largura: null,
    customData: {},
    pageLocation: null,
    url: null,
    protocol: null,
    path: null,
    host: null,
    ipUser: null,
    isPasswordVisible: false,
    thereIsBanner: false,
    showChannelSelect: false,
    channelSelectKey: 0,
  }),
  computed: {
    isHomolog() {
      return process.env.VUE_APP_HOMOLOG === '1';
    },
    classMessage: function () {
      return {
        "text-danger": this.error.status == "ERROR",
        "text-muted": !this.error.status == "ERROR",
      };
    },
    accessdocErrors() {
      const errors = [];
      if (!this.$v.form.accessdoc.$dirty) return errors;
      !this.$v.form.accessdoc.minLength &&
        errors.push("Digite um CPF/CNPJ válido");
      !this.$v.form.accessdoc.required &&
        errors.push("CPF/CNPJ é obrigatório!");

      if (this.$v.form.accessdoc.length === 14) {
        !this.$v.form.accessdoc.regexaccessdoc &&
          errors.push("CPF não é válido");
      } else if (this.$v.form.accessdoc.length === 18) {
        !this.$v.form.accessdoc.regexaccessdoc &&
          errors.push("CNPJ não é válido");
      }

      return errors;
    },
  },
  methods: {
    ...mapActions("auth", [
      "ActionDoLogin",
      "ActionGetContactsByDocNumber",
      "ActionSetCurrentForm",
      "ActionSetContacts",
      "ActionGetLinkAccessAsDebtor",
    ]),

    invalidateForm() {
      this.errors = true;
    },

    showContactsNotFound() {
      this.loading = false;
      this.error.status = "ERROR";
      this.flashMessage.show({
        time: 3000,
        status: "error",
        position: "top right",
        title: "Erro",
        message: CONTACTS_NOT_FOUND_MESSAGE,
      });
    },

    revealChannelSelect(accessdoc, results, route) {
      this.ActionSetContacts(
        results.SourceInfo === "EXTERNO"
          ? {
              DebtorID: results.DebtorID,
              DocNumber: results.DocNumber,
              Emails: results.Emails,
              PhoneNumbers: results.MobileNumbers,
              ListEmailsWithMask: results.ListEmailsWithMask,
              ListPhonesWithMask: results.ListPhonesWithMask,
              SourceInfo: "API_EXTERNA",
              FullName: results.FullName,
            }
          : results
      );
      this.loading = false;
      this.channelSelectKey += 1;
      this.showChannelSelect = true;

      // Analytics não pode impedir a tela de contatos de abrir.
      try {
        this.buildAndSetUserData(
          accessdoc,
          results.DebtorID,
          this.protocol + "//" + this.host + `/dashboard/${route}`,
          route
        );
        this.emitUpdatePageViewEvent(`/dashboard/${route}`);
        this.updateCustomData();
      } catch (e) {
        // ignore tracking errors
      }
    },

    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },

    async getContacts(isReceberCodigo) {
      //eslint-disable-next-line
      // debugger;
      var route = null;
      if (isReceberCodigo) {
        route = "quero-receber-o-codigo";
        const pageName = this.$options.name;
        const eventCategory = `portal-de-negociacao:porto:${pageName}`;
        const eventAction = "click:link:quero-receber-o-codigo";
        const eventData = {
          event: "select_content",
          ev_category: eventCategory,
          ev_action: eventAction,
          ev_label: "",
        };

        localStorage.setItem("currentPageName", "quero-receber-o-codigo");

        window.dataLayer.push({ event: "select_content", ...eventData });
      } else {
        route = "receber-codigo";
        const pageName = this.$options.name;
        const eventCategory = `portal-de-negociacao:porto:${pageName}`;
        const eventAction = "click:link:esqueci-o-codigo";
        const eventData = {
          event: "select_content",
          ev_category: eventCategory,
          ev_action: eventAction,
          ev_label: "",
        };

        localStorage.setItem("currentPageName", "receber-codigo");

        window.dataLayer.push({ event: "select_content", ...eventData });
      }

      this.loading = true;
      this.accessdocErrors.pop();
      this.$v.$touch();

      if (!this.form.accessdoc || this.form.accessdoc === "") {
        this.loading = false;
        const pageName = this.$options.name;
        const eventCategory = `portal-de-negociacao:porto:${pageName}`;
        const eventAction = "login:alert";
        const eventLabel = "Informe um CPF/CNPJ";
        const eventCode = 401;
        const eventErrorService = "";
        const eventAlertService = "Informe um CPF/CNPJ";
        const eventAlert = "login";
        const eventAlertType = "bloqueio";
        const eventData = {
          event: "alert",
          ev_category: eventCategory,
          ev_action: eventAction,
          ev_label: eventLabel,
          alert_code: eventCode,
          error_service: eventErrorService,
          alert_service_message: eventAlertService,
          alert_event: eventAlert,
          alert_type: eventAlertType,
        };

        window.dataLayer.push({ event: "alert", ...eventData });
        this.flashMessage.show({
          timeout: 300,
          status: "error",
          position: "top right",
          title: "Erro",
          message: "Informe um CPF/CNPJ",
        });
        this.loading = false;
        return;
      }

      var isDocValid = validaCpfCnpj(this.form.accessdoc);

      if (this.$v.$invalid || !isDocValid) {
        this.loading = false;
        if (!isDocValid) {
          const pageName = this.$options.name;
          const eventCategory = `portal-de-negociacao:porto:${pageName}`;
          const eventAction = "login:alert";
          const eventLabel = "Informe um CPF/CNPJ válido";
          const eventCode = 401;
          const eventErrorService = "";
          const eventAlertService = "Informe um CPF/CNPJ válido";
          const eventAlert = "login";
          const eventAlertType = "bloqueio";
          const eventData = {
            event: "alert",
            ev_category: eventCategory,
            ev_action: eventAction,
            ev_label: eventLabel,
            alert_code: eventCode,
            error_service: eventErrorService,
            alert_service_message: eventAlertService,
            alert_event: eventAlert,
            alert_type: eventAlertType,
          };

          window.dataLayer.push({ event: "alert", ...eventData });

          this.flashMessage.show({
            timeout: 300,
            status: "error",
            position: "top right",
            title: "Erro",
            message: "Informe um CPF/CNPJ válido",
          });
          return;
        }
      } else {
        // Remove apenas caracteres de formatação (mantém letras para CNPJ alfanumérico)
        let accessdoc = this.form.accessdoc.replace(/[.\-/]/g, "").toUpperCase();

        try {
          let response = await this.ActionGetContactsByDocNumber({
            DocNumber: accessdoc,
            OS: navigator.platform,
            IP: this.ipUser ? this.ipUser : "",
          });

          if (response.data?.error || !response.data.code || response.data.code !== 200) {
            let url = "https://portoseguro.com.br/negocie";
            this.flashMessage.show({
              time: 0,
              status: "error",
              position: "top right",
              title: "Ocorreu um erro",
              message: `Ops... tivemos um problema. Ligue para: SP: 4004-3600 Demais regiões: 0800 727 7477.`,
              html: `<div class="m-2"><p>Tivemos um problema. Encontre outros canais de negociação em:  <a href="${url}" target="_blank">${url}</a></p></div>`,
            });
            this.loading = false;
            return;
          }

          if (!hasContacts(response.data.results)) {
            this.showContactsNotFound();
            return;
          }

          this.revealChannelSelect(accessdoc, response.data.results, route);
        } catch (error) {
          this.error.status = "ERROR";
          this.loading = false;
          this.flashMessage.show({
            time: 3000,
            status: "error",
            position: "top right",
            title: "Erro",
            message: "Não foi possível carregar os contatos. Tente novamente.",
          });
        }
      }
    },

    buildAndSetUserData(doc, id, pageLocation, pageName) {
      const docEncrypted = this.encryptData(doc);
      const userData = {
        cpfCnpj: docEncrypted,
        id: id,
        page_location: pageLocation,
        pageName: pageName,
      };
      localStorage.setItem("userData", JSON.stringify(userData));
    },

    async login() {
      this.loading = true;

      this.$v.$touch();
      var isDocValid = validaCpfCnpj(this.form.accessdoc);

      if (this.$v.$invalid || !isDocValid) {
        this.loading = false;
        if (!isDocValid) {
          const pageName = this.$options.name;
          const eventCategory = `portal-de-negociacao:porto:${pageName}`;
          const eventAction = "login:alert";
          const eventLabel = "Informe um CPF/CNPJ válido";
          const eventCode = 401;
          const eventErrorService = "";
          const eventAlertService = "Informe um CPF/CNPJ válido";
          const eventAlert = "login";
          const eventAlertType = "bloqueio";
          const eventData = {
            event: "alert",
            ev_category: eventCategory,
            ev_action: eventAction,
            ev_label: eventLabel,
            alert_code: eventCode,
            error_service: eventErrorService,
            alert_service_message: eventAlertService,
            alert_event: eventAlert,
            alert_type: eventAlertType,
          };

          window.dataLayer.push({ event: "alert", ...eventData });

          this.flashMessage.show({
            timeout: 300,
            status: "error",
            position: "top right",
            title: "Erro",
            message: "Informe um CPF/CNPJ válido",
          });
          return;
        }
      }

      if (!this.isHomolog && (!this.form.promoCode || this.form.promoCode === "")) {
        this.loading = false;
        const pageName = this.$options.name;
        const eventCategory = `portal-de-negociacao:porto:${pageName}`;
        const eventAction = "login:alert";
        const eventLabel = "Informe o código de acesso";
        const eventCode = 401;
        const eventErrorService = "";
        const eventAlertService = "Informe o código de acesso";
        const eventAlert = "login";
        const eventAlertType = "bloqueio";
        const eventData = {
          event: "alert",
          ev_category: eventCategory,
          ev_action: eventAction,
          ev_label: eventLabel,
          alert_code: eventCode,
          error_service: eventErrorService,
          alert_service_message: eventAlertService,
          alert_event: eventAlert,
          alert_type: eventAlertType,
        };

        window.dataLayer.push({ event: "alert", ...eventData });
        this.flashMessage.show({
          timeout: 300,
          status: "error",
          position: "top right",
          title: "Erro",
          message: "Informe o código de acesso",
        });
        return;
      } else {
        // Remove apenas caracteres de formatação (mantém letras para CNPJ alfanumérico)
        let accessdoc = this.form.accessdoc.replace(/[.\-/]/g, "").toUpperCase();

        let response = await this.ActionGetContactsByDocNumber({
          DocNumber: accessdoc,
          OS: navigator.platform,
          IP: this.ipUser ? this.ipUser : "",
        });

        if (response.data?.error || !response.data.code || response.data.code !== 200) {
          let url = "https://portoseguro.com.br/negocie";
          this.flashMessage.show({
            time: 0,
            status: "error",
            position: "top right",
            title: "Erro",
            message:
              "Ops... tivemos um problema. Ligue para: SP: 4004-3600 Demais regiões: 0800 727 7477.",
            html: `<div class="m-2"><p>Tivemos um problema. Encontre outros canais de negociação em:  <a href="${url}" target="_blank">${url}</a></p></div>`,
          });

          this.loading = false;
          return;
        }

        if (!hasContacts(response.data.results) || !response.data.results?.DebtorID) {
          this.flashMessage.show({
            timeout: 300,
            status: "error",
            position: "top right",
            title: "Erro",
            message: CONTACTS_NOT_FOUND_MESSAGE,
          });
          this.loading = false;
          return;
        }

        if (response.data.results.SourceInfo == "EXTERNO") {
          this.ActionSetContacts({
            DocNumber: response.data.results.DocNumber,
            Emails: response.data.results.Emails,
            PhoneNumbers: response.data.results.MobileNumbers,
            ListEmailsWithMask: response.data.results.ListEmailsWithMask,
            ListPhonesWithMask: response.data.results.ListPhonesWithMask,
            SourceInfo: "API_EXTERNA",
          });
          this.contacts = response.data.results;
          this.loading = false;
        } else {
          let debtorId = response.data.results.DebtorID;
          let promoCode = this.isHomolog ? '' : this.form.promoCode;

          try {
            await this.ActionDoLogin({
              DebtorID: debtorId,
              PromoCode: promoCode,
              device_name: process.env.VUE_APP_API_DEVICE,
              IP: this.ipUser ? this.ipUser : "",
              OS: navigator.platform,
            });
            this.loading = false;

            this.buildAndSetUserData(
              accessdoc,
              debtorId,
              this.protocol + "//" + this.host + "/dashboard",
              "Dashboard"
            );
            await this.eventCallbackSuccessLoginGTM(accessdoc);
            this.updateCustomData();

            await this.$router.push({ name: "dashboard" });

            localStorage.setItem(
              "authUser",
              JSON.stringify(this.$store.state.auth.user)
            );

            window.location.reload();
          } catch (error) {
            this.loading = false;
            const pageName = this.$options.name;
            const eventCategory = `portal-de-negociacao:porto:${pageName}`;
            const eventAction = "login:alert";
            const eventLabel = error.data.message;
            const eventCode = error.status;
            const eventErrorService = "";
            const eventAlertService = error.data.message;
            const eventAlert = "login";
            const eventAlertType = "bloqueio";
            const eventData = {
              event: "alert",
              ev_category: eventCategory,
              ev_action: eventAction,
              ev_label: eventLabel,
              alert_code: eventCode,
              error_service: eventErrorService,
              alert_service_message: eventAlertService,
              alert_event: eventAlert,
              alert_type: eventAlertType,
            };

            window.dataLayer.push({ event: "alert", ...eventData });

            this.flashMessage.show({
              timeout: 300,
              status: "error",
              position: "top right",
              title: "Erro",
              message: "CPF/CNPJ ou código de acesso incorretos",
            });
            this.loading = false;
            return;
          }
        }
      }
    },

    saveDocument() {
      window.localStorage.setItem("doc", this.form.accessdoc);
    },

    convertToUpperCase() {
      // Converte CNPJ para maiúsculas (necessário para CNPJ alfanumérico)
      if (this.form.accessdoc) {
        this.form.accessdoc = this.form.accessdoc.toUpperCase();
      }
    },

    sendCodeForm() {
      this.ActionSetCurrentForm("form-send-code");
    },
    clear() {
      this.$v.$reset();
      this.form.accessdoc = "";
      this.form.termos = false;
    },

    async changeAccessDocInput() {
      const pageName = this.$options.name;
      const eventCategory = `portal-de-negociacao:porto:${pageName}`;
      const eventAction = "preencher:input:seu-cpf-ou-cnpj";
      const eventData = {
        event: "select_content",
        ev_category: eventCategory,
        ev_action: eventAction,
        ev_label: "",
      };

      window.dataLayer.push({ event: "select_content", ...eventData });
    },

    changeAccessCodeInput() {
      const pageName = this.$options.name;
      const eventCategory = `portal-de-negociacao:porto:${pageName}`;
      const eventAction = "preencher:input:codigo-de-acesso";
      const eventData = {
        event: "select_content",
        ev_category: eventCategory,
        ev_action: eventAction,
        ev_label: "",
      };

      window.dataLayer.push({ event: "select_content", ...eventData });
    },

    emitUpdatePageViewEvent(pageName) {
      EventBus.$emit("updatePageView", pageName);
    },

    encryptData(doc) {
      const encryptedData = encryptTextWithKey(doc, "chave");
      return encryptedData;
    },

    decryptData(value, key) {
      const decryptedData = decryptHashWithKey(value, key);
      return decryptedData.trim();
    },

    formatarCnpjCpf(cnpjCpf) {
      // Remove apenas caracteres de formatação (mantém letras para CNPJ alfanumérico)
      const limpo = cnpjCpf.replace(/[.\-/]/g, "").toUpperCase();

      if (limpo.length === 11) {
        // CPF (sempre numérico)
        return limpo.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
      } else if (limpo.length === 14) {
        // CNPJ (numérico ou alfanumérico)
        return limpo.replace(
          /^(.{2})(.{3})(.{3})(.{4})(.{2})$/,
          "$1.$2.$3/$4-$5"
        );
      } else {
        return cnpjCpf;
      }
    },

    eventCallbackSuccessLoginGTM(accessdoc) {
      const pageName = this.$options.name;
      const eventCategory = `portal-de-negociacao:porto:${pageName}`;
      const eventAction = "login:sucesso";
      const eventLabel = accessdoc.length <= 11 ? "pf" : "pj";
      const eventMethod = "senha";
      const eventData = {
        event: "login",
        ev_category: eventCategory,
        ev_action: eventAction,
        ev_label: eventLabel,
        method: eventMethod,
      };

      window.dataLayer.push({ event: "login", ...eventData });
    },

    updateCustomData() {
      const globals = initializeGlobals();
      window.customData = globals.customData;
    },

    async getIPAddressUser() {
      let maxAttempts = 10;
      let attempts = 0;

      while (attempts < maxAttempts) {
        try {
          this.ipUser = await ActionGetIPAddress();
          if (this.ipUser !== null) {
            localStorage.setItem("ipUser", this.ipUser);
          }
          break;
        } catch (error) {
          console.log("Erro ao obter o endereço IP. Tentando novamente...");
          attempts++;
          await new Promise((resolve) => setTimeout(resolve, 1000));
        }
      }

      if (attempts === maxAttempts) {
        console.log(
          "Número máximo de tentativas atingido. Não foi possível obter o endereço IP."
        );
      }
    },
  },

  async created() {
    await this.getIPAddressUser();

    // DX-2201: link de acesso direto curto (https://dominio/{codigo}). O código é
    // resolvido no backend via /getDirectLinkAccessV2 (shortCode -> encryptedData).
    // Formato antigo (?SApp=/?cod=) continua funcionando sem nenhuma mudança abaixo.
    if (this.$route.params.shortCode) {
      localStorage.setItem("shortCode", this.$route.params.shortCode);
      localStorage.removeItem("infoEncrypted");
      localStorage.removeItem("encryptedData");
      this.ActionSetCurrentForm("fake-loading");
    }

    if (this.$route.query.SApp) {
      localStorage.setItem(
        "encryptedData",
        this.$route.query.SApp.replaceAll(" ", "+")
      );
      localStorage.removeItem("infoEncrypted");
      this.ActionSetCurrentForm("fake-loading");
    }

    if (this.$route.query.cod) {
      var infoEncrypted = this.$route.query.cod;
      if (infoEncrypted !== null) {
        localStorage.setItem("infoEncrypted", infoEncrypted);
        localStorage.removeItem("encryptedData");
        this.ActionSetCurrentForm("fake-loading");
      } else {
        this.flashMessage.show({
          timeout: 300,
          status: "error",
          position: "top right",
          title: "Erro",
          message: "Ocorreu um erro.",
        });
        return;
      }
    }

    this.protocol = window.location.protocol;
    this.host = window.location.host;
    this.path = window.location.pathname;
    this.pageLocation = this.protocol + "//" + this.host + this.path;
    this.buildAndSetUserData(null, null, this.pageLocation, "Login");
    this.$emit("updatePageView", this.pageLocation);
    this.updateCustomData();

    this.largura = typeof window !== "undefined" ? window.innerWidth : window.screen.width;
  },
  activated() {
    // "Não recebi o código" reabre a seleção de canal; demais retornos voltam ao CPF.
    const reopenChannel = localStorage.getItem("reopenChannelSelect") === "1";
    if (reopenChannel) {
      localStorage.removeItem("reopenChannelSelect");
      if (hasContacts(this.$store.state.auth.contacts)) {
        this.channelSelectKey += 1;
        this.showChannelSelect = true;
      } else if (this.form.accessdoc) {
        // Contatos foram perdidos no store — busca de novo.
        this.getContacts(true);
      } else {
        this.showChannelSelect = false;
      }
    } else {
      this.showChannelSelect = false;
    }
  },
  mounted() {
    const onResize = () => {
      this.largura = window.innerWidth;
    };
    window.addEventListener("resize", onResize);
    this._loginResizeHandler = onResize;
  },
  beforeDestroy() {
    if (this._loginResizeHandler) {
      window.removeEventListener("resize", this._loginResizeHandler);
    }
  },
};
</script>
<style>
/* Fonte igual à Landing (Cabin) – propaga para todo o card inclusive inputs/botões */
.login-new-wrapper,
.login-new-wrapper .login-new-card,
.login-new-wrapper .card-body,
.login-new-wrapper .card-body *:not(.fa):not([class*="fa-"]),
.login-new-wrapper input,
.login-new-wrapper button,
.login-new-wrapper label,
.login-new-wrapper p,
.login-new-wrapper h4,
.login-new-wrapper h5,
.login-new-wrapper h6,
.login-new-wrapper a {
  font-family: "Cabin", sans-serif !important;
}
/* Ícone de olho (Font Awesome) no input de senha – não usar Cabin */
.login-new-wrapper .fa,
.login-new-wrapper i[class*="fa-"] {
  font-family: "Font Awesome 4 Free", "FontAwesome" !important;
  font-weight: 900;
}

/* Card do login novo: cantos superiores suaves, cantos inferiores mais arredondados (como referência img 2) */
.login-new-card {
  border-radius: 12px 12px 24px 24px !important;
  border: none !important;
  width: 100%;
  max-width: 420px;
  margin-left: auto;
  margin-right: auto;
}

/* Desktop largo: painel da arte ~1:1 (igual à imagem) + cover sem faixas */
.login-new-desktop {
  background-color: #0046c0;
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: stretch;
  box-sizing: border-box;
}

.login-new-left {
  flex: 0 0 auto;
  width: min(56vw, 100vh);
  max-width: 62%;
  min-width: 0;
  position: relative;
  overflow: hidden;
  background-color: #0046c0;
}

.login-new-hero-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  display: block;
}

.login-new-right {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1.5rem;
  box-sizing: border-box;
  background-color: #0046c0;
}

.login-new-right .login-new-card {
  flex: 0 1 420px;
  width: 100%;
  max-width: 420px;
  margin: 0 auto;
}

/* Loading centralizado no lugar do botão "Negociar agora" */
.login-new-wrapper form {
  width: 100%;
}

.login-card-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 52px;
}

/* Empilhado (imagem em cima, card embaixo): sem borda/sombra no topo do card = conexão harmônica */
.login-new-stacked-card,
.login-new-stacked-card.card {
  border: none !important;
  border-top: none !important;
  box-shadow: none !important;
}
.login-new-stacked-card .card-body {
  border-top: none !important;
}

/* Mobile (card em cima, imagem embaixo): sem borda/sombra na base do card = conexão harmônica */
.login-new-mobile-card,
.login-new-mobile-card.card {
  border: none !important;
  border-bottom: none !important;
  box-shadow: none !important;
}
.login-new-mobile-card .card-body {
  border-bottom: none !important;
}

/* Alinhamento: imagem e card na mesma largura, sem deslocamento */
.login-new-stacked-block,
.login-new-mobile-block {
  margin-left: auto;
  margin-right: auto;
}
.login-new-stacked-block img,
.login-new-stacked-block .card,
.login-new-mobile-block img,
.login-new-mobile-block .card {
  margin-left: 0 !important;
  margin-right: 0 !important;
  max-width: 100%;
}
.login-new-stacked-block img,
.login-new-mobile-block img {
  display: block;
}

/* Mobile: imagem abaixo do card, mesma largura do bloco (margens iguais à Landing) */
.login-new-mobile-img-below {
  display: block;
}

/* Mobile: margens semelhantes à Landing; evita que layout pai (.row .col padding:0) trave */
@media (max-width: 500px) {
  .login-new-mobile {
    width: 100% !important;
    max-width: 100vw !important;
    margin-left: auto !important;
    margin-right: auto !important;
    padding: 2rem 1.25rem 1rem 1.25rem !important;
    box-sizing: border-box !important;
    min-width: 0 !important;
  }
  .login-new-mobile-block {
    width: 100% !important;
    max-width: 420px !important;
    margin-left: auto !important;
    margin-right: auto !important;
  }
}

.mx-64 {
  margin-left: 64px !important;
  margin-right: 64px !important;
}
.nowrap {
  flex-wrap: nowrap !important;
}

@media (max-width: 768px) {
  div[style*="backgroundImage"] {
    height: auto; /* Permite que a altura seja ajustada automaticamente */
  }
}

/* FAQ: perguntas do acordeão em azul Porto */
#faq .card .btn-link {
  color: #0046c0 !important;
}
#faq .card .btn-link:hover,
#faq .card .btn-link:focus {
  color: #00389a !important;
}
</style>

<!-- Sem scoped: fonte igual à Landing + margens e conexão card-imagem (sobrescreve tema) -->
<style>
/* Fonte do card igual à Landing (Cabin) – propaga para todo o card */
.login-new-wrapper,
.login-new-wrapper .login-new-card,
.login-new-wrapper .card-body,
.login-new-wrapper .card-body *:not(.fa):not([class*="fa-"]),
.login-new-wrapper input,
.login-new-wrapper button,
.login-new-wrapper label,
.login-new-wrapper p,
.login-new-wrapper h4,
.login-new-wrapper h5,
.login-new-wrapper h6,
.login-new-wrapper a {
  font-family: "Cabin", sans-serif !important;
}
/* Ícone de olho (Font Awesome) no input de senha */
.login-new-wrapper .fa,
.login-new-wrapper i[class*="fa-"] {
  font-family: "Font Awesome 4 Free", "FontAwesome" !important;
  font-weight: 900;
}

/* Empilhado: card abaixo da imagem – sem linha no topo do card */
.login-new-stacked-card,
.login-new-stacked-card.card {
  border: none !important;
  border-top: none !important;
  box-shadow: none !important;
}
.login-new-stacked-card .card-body {
  border-top: none !important;
}

/* Mobile: card acima da imagem – sem linha na base do card */
.login-new-mobile-card,
.login-new-mobile-card.card {
  border: none !important;
  border-bottom: none !important;
  box-shadow: none !important;
}
.login-new-mobile-card .card-body {
  border-bottom: none !important;
}

@media (max-width: 500px) {
  .login-new-mobile.login-new-wrapper,
  body .login-new-mobile {
    width: 100% !important;
    max-width: 100vw !important;
    margin-left: auto !important;
    margin-right: auto !important;
    padding: 2rem 1.25rem 1rem 1.25rem !important;
    box-sizing: border-box !important;
  }
  .login-new-mobile .login-new-mobile-block {
    margin-left: auto !important;
    margin-right: auto !important;
  }
}
</style>